import { MainRoutes } from "ui/common/router/MainRouter.types";

const customAppbarRoutes: MainRoutes[] = [MainRoutes.GIFT_CARDS, MainRoutes.GIFT_CARDS_DETAILS, MainRoutes.GIFT_CARDS_REDEEM];

function verifyCustomAppbarRoute(route: string): boolean {
    return (Object.values(customAppbarRoutes) as string[]).includes(route);
}

export default verifyCustomAppbarRoute;
